__turbopack_context__.v({
  "action-bar": "SocialBar-module-scss-module__5-oj1G__action-bar",
  "buttons": "SocialBar-module-scss-module__5-oj1G__buttons",
  "label-category": "SocialBar-module-scss-module__5-oj1G__label-category",
  "share-button": "SocialBar-module-scss-module__5-oj1G__share-button",
});
